import { EmptyState, FlexBox, Text } from '@dixa/lib-shared-habla';

import { SearchResultsFeedback } from '../feedback/searchResultsFeedback';

/**
 * Represents a component that is used to visualize the view when there are no
 * results.
 */
export const SearchResultsEmpty = (): JSX.Element => (
  <FlexBox
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100%"
  >
    <EmptyState
      title="No results found for this search"
      description={
        <FlexBox flexDirection="column" gap="300">
          <Text.Paragraph>
            You may want to try using different keywords, checking for typos, or
            adjusting your filters.
          </Text.Paragraph>

          <SearchResultsFeedback />
        </FlexBox>
      }
    />
  </FlexBox>
);
